import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { api, errorMessage } from "@/lib/api";
import { L } from "@/i18n";

export const STATUS_LABELS = { approved: ["approved", "aprovado"], pending: ["pending", "pendente"], blocked: ["blocked", "bloqueado"], rejected: ["rejected", "rejeitado"] };

const fetchUsers = async () => {
  const { data } = await api.get("/admin/users");
  const list = Array.isArray(data) ? data : data?.users ?? [];
  return list.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
};

export const useUsers = () => useQuery({ queryKey: ["users"], queryFn: fetchUsers, staleTime: 0 });

const useInvalidate = () => {
  const qc = useQueryClient();
  return () => {
    qc.invalidateQueries({ queryKey: ["users"] });
    qc.invalidateQueries({ queryKey: ["dashboard"] });
  };
};

export const useUpdateStatus = () => {
  const invalidate = useInvalidate();
  return useMutation({
    mutationFn: ({ id, status }) => api.put(`/admin/users/${id}/status`, { status }),
    onSuccess: (_, { username, status }) => {
      toast.success(L("{u} has been marked as {s}.", "{u} foi marcado como {s}.", { u: username, s: L(...STATUS_LABELS[status]) }));
      invalidate();
    },
    onError: (e) => toast.error(L("Failed to update status: {e}", "Falha ao atualizar estado: {e}", { e: errorMessage(e) })),
  });
};

export const useDeleteUser = () => {
  const invalidate = useInvalidate();
  return useMutation({
    mutationFn: ({ id }) => api.delete(`/admin/users/${id}`),
    onSuccess: (_, { username }) => {
      toast.success(L("{u} has been deleted.", "{u} foi eliminado.", { u: username }));
      invalidate();
    },
    onError: (e) => toast.error(L("Failed to delete: {e}", "Falha ao eliminar: {e}", { e: errorMessage(e) })),
  });
};
